module.exports = " <ul class=list-unstyled> <li v-for=\"option in config.options\"> <input type=checkbox name=\"{{ name }}[]\" :id=\"name + '-' + $index\" :value=option.value v-model=data /> <label :for=\"name + '-' + $index\">{{ option.text }}</label> </li> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/CheckboxesFieldtype.vue
// module id = 566
// module chunks = 0